import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../store/appStore';
import api from '../services/api';

export const useInactivityTimer = () => {
  const navigate = useNavigate();
  const isAuditRunning = useAppStore((state) => state.isAuditRunning);
  const [timeoutMinutes, setTimeoutMinutes] = useState(15); // Default value

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await api.get('/api/v1/settings');
        setTimeoutMinutes(response.data.inactivity_timeout_minutes);
      } catch (error) {
        console.error('Error fetching inactivity timeout setting:', error);
      }
    };

    fetchSettings();
  }, []);

  const logout = useCallback(() => {
    // Clear user session, token, etc.
    localStorage.removeItem('user');
    navigate('/login');
  }, [navigate]);

  useEffect(() => {
    let inactivityTimer: NodeJS.Timeout;

    const resetTimer = () => {
      clearTimeout(inactivityTimer);
      if (!isAuditRunning) {
        inactivityTimer = setTimeout(logout, timeoutMinutes * 60 * 1000);
      }
    };

    if (timeoutMinutes > 0) {
        window.addEventListener('mousemove', resetTimer);
        window.addEventListener('mousedown', resetTimer);
        window.addEventListener('keypress', resetTimer);
        window.addEventListener('scroll', resetTimer);
        window.addEventListener('touchstart', resetTimer);
        resetTimer();
    }

    return () => {
      clearTimeout(inactivityTimer);
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('mousedown', resetTimer);
      window.removeEventListener('keypress', resetTimer);
      window.removeEventListener('scroll', resetTimer);
      window.removeEventListener('touchstart', resetTimer);
    };
  }, [isAuditRunning, logout, timeoutMinutes]);

  return null;
};